import { DatePicker } from '@mui/x-date-pickers/DatePicker'
import { MobileDateTimePicker } from '@mui/x-date-pickers/MobileDateTimePicker'
import { MobileTimePicker } from '@mui/x-date-pickers/MobileTimePicker'
import dayjs from 'dayjs'
import 'dayjs/locale/es'
import { translateMask } from 'features/solicitudes/libs/DateFieldsHelpers'
import { useEffect, useState } from 'react'

const CustomDateTimeComponent = ({ campo, dates, valor, onChange = (v) => {} }) => {
  const { openTo, views } = translateMask(campo.mascara_formato)

  const [value, setValue] = useState(
    valor ? (typeof valor === 'string' ? dayjs(valor) : valor) : null,
  )

  const handleChange = (newValue) => {
    setValue(newValue)

    if (!newValue.isValid()) return

    // Evitar validación antes de que se escriba el año completo
    const year = newValue.year()
    if (year < 1000) return

    onChange(newValue)
  }

  useEffect(() => {
    if (valor) setValue(dayjs(valor))
  }, [valor])

  if (views && !views.includes('day') && !views.includes('month') && !views.includes('year')) {
    return (
      <MobileTimePicker
        placeholder={`${campo.etiqueta}${campo.obligatorio === 'S' ? ' *' : ''}`}
        views={views}
        openTo={openTo}
        value={value}
        onChange={handleChange}
        slotProps={{
          clearable: true,
          textField: {
            helperText: campo.ayuda,
            error: campo.error,
          },
        }}
        mindate={dates?.mindate ?? null}
        maxdate={dates?.maxdate ?? null}
        sx={{ width: '100%' }}
        disabled={campo.informativo === 'S'}
      />
    )
  }
  if (
    views &&
    !views.includes('hours') &&
    !views.includes('minutes') &&
    !views.includes('seconds')
  ) {
    return (
      <DatePicker
        placeholder={`${campo.etiqueta}${campo.obligatorio === 'S' ? ' *' : ''}`}
        views={
          views.includes('day') && views.includes('month') && views.includes('year') ? null : views
        }
        value={value}
        onChange={handleChange}
        slotProps={{
          clearable: true,
          textField: {
            helperText: campo.ayuda,
            error: campo.error,
          },
        }}
        mindate={dates?.mindate ?? null}
        maxdate={dates?.maxdate ?? null}
        sx={{ width: '100%' }}
        disabled={campo.informativo === 'S'}
      />
    )
  }
  return (
    <MobileDateTimePicker
      placeholder={`${campo.etiqueta}${campo.obligatorio === 'S' ? ' *' : ''}`}
      views={views}
      openTo={openTo}
      value={value}
      onChange={handleChange}
      slotProps={{
        clearable: true,
        textField: {
          helperText: campo.ayuda,
          error: campo.error,
        },
      }}
      mindate={dates?.mindate ?? null}
      maxdate={dates?.maxdate ?? null}
      sx={{ width: '100%' }}
      disabled={campo.informativo === 'S'}
    />
  )
}

export default CustomDateTimeComponent
